import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import * as _ from 'lodash';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DroppableDirective } from '../../../core/visual/droppable/droppable.directive';
import { FileHelpers } from '../../../core/utilities/file.helpers';

@Component({
  selector: 'app-upload-custom-audio-file',
  templateUrl: './upload-custom-audio-file.component.html',
  styleUrls: ['./upload-custom-audio-file.component.scss'],
  standalone: true,
  imports: [DroppableDirective],
})
export class UploadCustomAudioFileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() id: string;
  @Input() name: string;
  @Input() allowImages: boolean;

  _id: string;

  file: File;
  previewUrl: string;
  previewFileName: string;

  containerHeight = 100;
  resizeSubscription: Subscription;

  @ViewChild('fileInput', { static: true }) fileInput: any;
  @ViewChild('audioPreview') audioPreview: any;
  @ViewChild('previewContainer') previewContainer: ElementRef;

  @Output() valueChanged = new EventEmitter<File>();
  @Output() validationError = new EventEmitter<string>();

  constructor() {
    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(300))
      .subscribe(event => {
        console.log('On resize fax upload');
        this.updateSize();
      });
  }

  setId(): void {
    if (this.id) {
      this._id = this.id;
    } else if (this.name) {
      this._id = this._id = _.uniqueId(`${this.name}_`);
    } else {
      this._id = _.uniqueId('id_');
    }
  }

  fileChangeEvent(fileInput: any) {
    const files = fileInput.target.files;
    if (files.length > 0) {
      const file: File = files[0];
      this.validateAndProceedFile(file);
    }
  }

  dropFile(event: DragEvent) {
    console.log('drop event');

    const files = event.dataTransfer.files;

    if (files.length > 0) {
      const file: File = files[0];
      this.validateAndProceedFile(file);
    }
  }

  validateAndProceedFile(file: File) {
    if (FileHelpers.isSupportedFile(file, 'audio')) {
      this.file = file;
      this.valueChanged.emit(file);
      this.previewFile(file);
    } else {
      this.validationError.emit('File type is not supported');
    }
  }

  removeAttachment() {
    this.file = undefined;
    this.previewUrl = null;
    this.previewFileName = null;
    if (this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }

    this.valueChanged.emit(this.file);
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }

  ngOnInit(): void {
    this.setId();
    this.updateSize();
  }

  updateSize() {
    if (this.previewContainer) {
      this.containerHeight = this.previewContainer.nativeElement.clientWidth * 1.4142 + 10;
    }
  }

  ngOnDestroy(): void {
    if (this.resizeSubscription) {
      this.resizeSubscription?.unsubscribe();
    }
  }

  private previewFile(file: File) {
    this.previewFileName = file.name;
    this.previewUrl = null;

    if (file.type.indexOf('audio') > -1) {
      console.log('preview audio');
      this.previewUrl = URL.createObjectURL(file);
      setTimeout(() => {
        this.audioPreview.nativeElement.src = this.previewUrl;
      }, 10);

      // this.audioPreview.nativeElement.play();

      /*const reader = new FileReader();

      reader.onload = (e: any) => {
        this.previewUrl = e.target.result;
        this.updateSize();
      };

      reader.readAsDataURL(file);*/
    }
  }
}
